import script from "./orderDetailsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./orderDetailsDialog.vue?vue&type=script&setup=true&lang=js"

import "./orderDetailsDialog.vue?vue&type=style&index=0&id=8f4c4f16&lang=scss&scoped=true"

import exportComponent from "/home/kain/brighten-legacy/brightenflower2024-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f4c4f16"]])

export default __exports__